import React from 'react'
import PropTypes from 'prop-types'
import {SimpleGrid} from '@chakra-ui/react'

const WarrantyFormContainer = (props) => (
    <SimpleGrid columns={{base: 1, md: 2}} gap={4} {...props} />
)

WarrantyFormContainer.propTypes = {
    children: PropTypes.node.isRequired,
    columns: PropTypes.object
}

export default WarrantyFormContainer
